import { render, staticRenderFns } from "./DetalleValoracionModulos.vue?vue&type=template&id=310ec6cc"
import script from "./DetalleValoracionModulos.vue?vue&type=script&lang=js"
export * from "./DetalleValoracionModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports